import Vue from "vue";
import Vuex from "vuex";
import preferences from "./modules/preferences";
import messages from "./modules/messages";
import layout from "./modules/layout";
import curtains from "./modules/curtains";
import logs from "./modules/logs";
import drilling from "./modules/drilling";
Vue.use(Vuex);
var debug = process.env.NODE_ENV !== "production";
export default new Vuex.Store({
  modules: {
    preferences: preferences,
    messages: messages,
    layout: layout,
    curtains: curtains,
    logs: logs,
    drilling: drilling
  },
  strict: debug
});